import { resolveHolidays } from '@classy/shared';
import type { CalendarCell } from './calendarMath.js';
import birthdayImg from '../../../../../assets/calendar/Birthday-transparent.png';
import styles from './DayCell.module.css';

export interface DayCellProps {
  cell: CalendarCell;
  isToday: boolean;
  isSelected: boolean;
  events: string[];
  birthdays: string[];
  onSelect: () => void;
}

export function DayCell({ cell, isToday, isSelected, events, birthdays, onSelect }: DayCellProps) {
  const holidays = resolveHolidays(cell.date);
  const hasFederal = !!holidays.federal;
  const hasFun = !!holidays.fun;
  const hasBirthday = birthdays.length > 0;

  return (
    <button
      type="button"
      onClick={onSelect}
      className={styles.cell}
      data-testid="day-cell"
      data-iso={cell.iso}
      data-in-month={cell.inMonth}
      data-today={isToday}
      data-selected={isSelected}
      data-has-federal={hasFederal}
      aria-label={cell.iso}
    >
      <span className={styles.dayNumber}>{cell.date.getDate()}</span>

      <div className={styles.pills}>
        {hasFederal ? (
          <span className={`${styles.pill} ${styles.pillFederal}`}>{holidays.federal}</span>
        ) : null}
        {hasFun ? <span className={`${styles.pill} ${styles.pillFun}`}>{holidays.fun}</span> : null}
        {events.map((title, i) => (
          <span key={`ev-${i}`} className={`${styles.pill} ${styles.pillEvent}`}>
            {title}
          </span>
        ))}
      </div>

      {hasBirthday ? (
        <img
          src={birthdayImg}
          alt=""
          className={styles.birthday}
          aria-label={`Birthdays: ${birthdays.join(', ')}`}
          data-testid="day-cell-birthday"
        />
      ) : null}
    </button>
  );
}
